import { ImageWithFallback } from "@/components/image/ImageWithFallback";
import { StreamName } from "@/modules/analytics";
import { trackNavClick } from "@/utils/trackNavClick";
import classNames from "classnames";
import useTranslation from "next-translate/useTranslation";
import Link from "next/link";
import type { FC } from "react";
import styles from "../mobile-menu/MobileMenu.module.scss";

declare global {
  interface Window {
    opera?: string;
    MSStream?: string;
  }
}

export function isAndroid(): boolean {
  const android = true;
  const ios = false;
  try {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const userAgent =
      navigator.userAgent ||
      navigator.vendor ||
      (window.opera != null ? window.opera : "") ||
      "";

    // Check for Android
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    if (/android/i.test(userAgent)) {
      return android;
    }

    // Check for iOS
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/strict-boolean-expressions, @typescript-eslint/no-unnecessary-condition
    if (/iPad|iPhone|iPod/.test(userAgent) && !window?.MSStream) {
      return ios;
    }

    // If none of the above, it's not a mobile device or the OS isn't detected
    return android;
  } catch {
    return android;
  }
}

export const GetTheAppComponent: FC<{
  imageLightUrl?: string;
  imageDarkUrl?: string;
}> = ({ imageLightUrl, imageDarkUrl }) => {
  const { t } = useTranslation("web-payments");

  const imageLight = imageLightUrl ?? t(`GETTA_URL_IMAGE_LIGHT`) ?? "";
  const imageDark = imageDarkUrl ?? t(`GETTA_URL_IMAGE_DARK`) ?? "";
  const alttext = t(`GETTA_URL_IMAGE_TEXT_ALT`);

  const getMobileLink = () => {
    const android = t("GETTA_URL_LINK_ANDROID");
    const ios = t("GETTA_URL_LINK_IOS");
    return isAndroid() ? android : ios;
  };

  return (
    <Link
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
      className={classNames("title-7-bold", styles.mobileLink, styles.mainLink)}
      style={{
        marginLeft: "1rem",
      }}
      onClick={() => {
        trackNavClick(StreamName.Getta);
      }}
      href={getMobileLink()}
      target="_blank"
    >
      <ImageWithFallback
        alt={alttext}
        src={imageLight}
        darkModeSrc={imageDark}
        width={125}
        height={44}
        style={{
          height: "100%",
          width: "auto",
        }}
      />
    </Link>
  );
};
